"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[9136],{

/***/ 20230
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grab_dark.4ee8d28b.svg";

/***/ },

/***/ 5878
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grab_light.322c3334.svg";

/***/ },

/***/ 12326
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grafana_text_logo_dark.70a1e5ee.svg";

/***/ },

/***/ 71542
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grafana_text_logo_light.467e047c.svg";

/***/ }

}]);